import React from 'react';
import Camera from './Camera';
//import coordinates from './coordinates.json';
//import coordinates2 from './coordinates2.json';

import './App.css';
import CamSkeleton from './CamSkeleton';
import CamSkeletonPuddle from './CamSkeletonPuddle';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GameGrid from './GameGrid';



const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<GameGrid />} />
        <Route path="/CamSkeleton" element={<CamSkeleton />} />
        <Route path="/CamSkeletonPuddle" element={<CamSkeletonPuddle />} />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
};

export default App;
